import { create } from 'apisauce';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';

// eslint-disable-next-line import/no-cycle
import { actionCreators as authActions } from '../redux/Auth/actions';
import { actionCreators as toastActions } from '../redux/Toasts/actions';

import I18next from './i18n';

import { DEFAULT_PUBLIC_ROUTE } from '../app/components/Routes/constants';

const { REACT_APP_API_BASE_URL } = process.env;

const api = create({
  baseURL: REACT_APP_API_BASE_URL,
  timeout: 15000,
});

export const apiSetup = (dispatch) => {
  const bindedAuthActions = bindActionCreators(authActions, dispatch);
  const bindedPush = action => dispatch(push(action));
  const bindedToastActions = bindActionCreators(toastActions, dispatch);

  api.addRequestTransform((transform) => {
    /* eslint-disable no-param-reassign */
    transform.params = transform.params || {};
    transform.params.locale = I18next.language;
    /* eslint-enable no-param-reassign */
  });

  api.addMonitor((response) => {
    if (response.status === 401) {
      bindedAuthActions.logout();
      bindedPush(DEFAULT_PUBLIC_ROUTE);
    }
  });

  api.addMonitor((response) => {
    switch (response.problem) {
      case 'NETWORK_ERROR': {
        bindedToastActions.addToast({
          type: 'error',
          message: I18next.t('errors.network.noConnection'),
        });
        break;
      }
      case 'TIMEOUT_ERROR': {
        bindedToastActions.addToast({
          type: 'error',
          message: I18next.t('errors.network.timeout'),
        });
        break;
      }
      default: {
        break;
      }
    }
  });
};

export default api;



// WEBPACK FOOTER //
// ./src/config/api.js